import * as ActionTypes from 'actions/partnerPlan'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  partnerPlan: {},
  partnerPlanDocuments: [],
  partnerPlanEmailReminder: [],
}

// Updates error message to notify about the failed fetches.
export default function partnerPlan(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNERPLAN_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.PARTNERPLAN_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerPlan: action.partnerPlan,
      }
    case ActionTypes.PARTNERPLAN_DOCUMENT_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerPlanDocuments: action.partnerPlanDocuments,
      }
    case ActionTypes.PARTNERPLAN_CREATE_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
      }
    case ActionTypes.PARTNERPLAN_REMINDEREMAIL_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerPlanEmailReminder: action.partnerPlanEmailReminder,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerPlan.js